<div class="body" [formGroup]="formGroup">

    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>add_location</mat-icon>
        </button>
        <span>Standort anlegen</span>
        <span class="spacer"></span>
        <span matSuffix>

            <button mat-icon-button color="warn" (click)="close()">
                <mat-icon>close</mat-icon>
            </button>

        </span>
    </mat-toolbar>

    <div class="content">

        <app-address-form formGroupName="address" [appearance]="'fill'" style="margin-bottom: 1rem;"></app-address-form>

        <app-location-form formGroupName="location" [appearance]="'fill'"></app-location-form>

    </div>

    <div class="footer">

        <button [disabled]="formGroup.invalid" (click)="saveLocation()" mat-raised-button color="primary">
            Speichern
        </button>

    </div>

</div>
